export default __webpack_public_path__ + "static/media/cmb_discover.87757bdc.svg";